import { AUTH_URL, LOGOUT_URL } from "./Constants"
import { IRefresh } from "./model/IRefresh"
import { parseJwt } from "./Utils";
import * as GraphProvider from "./GraphProvider"
import { StorageItem } from "../service/constants";

export interface User {
  email: string;
  name: string;
}

const refresh = async (refreshToken: string): Promise<IRefresh> => await (await fetch(`${AUTH_URL}/refresh`, {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'refresh_token': refreshToken
  }
})).json();

const setTokens = (value: IRefresh) => localStorage.setItem(StorageItem.Tokens, JSON.stringify(value));

const getTokens = (): IRefresh => {
  try {
    return JSON.parse(localStorage.getItem(StorageItem.Tokens));
  } catch {
    return undefined;
  }
}

const getValidAccessToken = (): string | undefined => {
  const tokens = getTokens();


  if (!tokens || !tokens.access_token || !tokens.expires || Date.now() > new Date(tokens.expires).getTime() - 5 * 60 * 1000)
    return undefined;

  return tokens.access_token;
}

const refreshTokens = async (silent: boolean): Promise<string | undefined> => {
  const tokens = getTokens();
  if (!tokens || !tokens.refresh_token) {
    silent || login();
    return undefined;
  }

  try {
    const refreshObj = await refresh(tokens.refresh_token);
    setTokens(refreshObj);
    return refreshObj.access_token;
  } catch {
    silent || login();
    return undefined;
  }
}

export const login = () => {
  const searchParams = new URLSearchParams({
    prompt: 'select_account',
    redirect_uri: window.location.origin + '/login.html'
  })

  Office.context.ui.displayDialogAsync(`${AUTH_URL}/login?${searchParams.toString()}`, {
    height: 50,
    width: 50
  },
    (res) => {
      if (res.value) {
        res.value.addEventHandler(Office.EventType.DialogMessageReceived,
          async (arg) => {
            const params = JSON.parse(arg['message']);
            if (params) {
              const { refreshToken, graphToken } = params;

              if (refreshToken) {
                const refreshObj = await refresh(refreshToken);
                setTokens(refreshObj);
                const graphObj = await GraphProvider.requestTokens(graphToken);
                GraphProvider.setTokens(graphObj);
              }
            }
            res.value.close();
            window.location.reload();
          })
        res.value.addEventHandler(Office.EventType.DialogEventReceived,
          async (arg) => {
            if (arg['message'] = 'dialogClosed') {
              window.location.reload();
            }
          })
      }
    })
}

let refreshPromise: Promise<string> = null;
export const acquireAccessToken = async (silent: boolean = false): Promise<string> => {
  const validAccessToken = getValidAccessToken();
  if (validAccessToken) return validAccessToken;

  if (refreshPromise === null) {
    refreshPromise = refreshTokens(silent);
    const result = await refreshPromise;
    refreshPromise = null;
    return result;
  }

  return await refreshPromise;
}


export const getUser = async (): Promise<User | undefined> => {
  const accessToken = await acquireAccessToken(true);
  if (!accessToken) {
    return undefined;
  }

  const user = parseJwt(accessToken) as User;
  return user;
}

export const logout = () => {
  localStorage.clear();
  const searchParams = new URLSearchParams({
    post_logout_redirect_uri: window.location.origin + '/logout.html'
  })

  Office.context.ui.displayDialogAsync(`${LOGOUT_URL}?${searchParams}`, {
    height: 50,
    width: 50
  },
    (res) => {
      if (res.value) {
        res.value.addEventHandler(Office.EventType.DialogMessageReceived,
          async (arg) => {
            res.value.close();
            window.location.reload();
          })

        res.value.addEventHandler(Office.EventType.DialogEventReceived,
          async (arg) => {
            if (arg['message'] = 'dialogClosed') {
              window.location.reload();
            }
          })
      }
    })
}